import {
  DuckIcon,
  BoatIcon,
  BowIcon,
  HeartEyes,
  ThreeHearts,
  EyeLids,
  TennRackets,
  Clubs,
  Paddles,
  FlutesIcon,
  palmIcon,
  sandShellIcon,
  coralShellIcon,
} from "./icons";

const iconsTabFonts = [
  { font: "Duck", iconBadge: DuckIcon, iconPreview: DuckIcon },
  { font: "Boat", iconBadge: BoatIcon, iconPreview: BoatIcon },
  { font: "Bow", iconBadge: BowIcon, iconPreview: BowIcon },
  { font: "2 Hearts", iconBadge: HeartEyes, iconPreview: HeartEyes },
  { font: "3 Hearts", iconBadge: ThreeHearts, iconPreview: ThreeHearts },
  { font: "Eyelids", iconBadge: EyeLids, iconPreview: EyeLids },
  { font: "Rackets", iconBadge: TennRackets, iconPreview: TennRackets },
  { font: "Clubs", iconBadge: Clubs, iconPreview: Clubs },
  { font: "Paddles", iconBadge: Paddles, iconPreview: Paddles },
  { font: "Flutes", iconBadge: FlutesIcon, iconPreview: FlutesIcon },
  { font: "Palm", iconBadge: palmIcon, iconPreview: palmIcon },
  { font: "Sand Shell", iconBadge: sandShellIcon, iconPreview: sandShellIcon },
  { font: "Coral Shell", iconBadge: coralShellIcon, iconPreview: coralShellIcon },
];

export default iconsTabFonts;
